import { get, put, post, del } from '../request';

export async function fetchConfigurationPortal(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/portal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConfigurationPortal(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/config/portal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchConfigurationAppeal(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/appeals`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConfigurationAppeal(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/config/appeals`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchConfigurationEmail(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/email`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConfigurationEmail(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/config/email`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAllPublicCheckInConfig(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/checkin`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPublicCheckInConfig(
  { publicService },
  authenticationToken,
  { configID }
) {
  const url = `${publicService}/public/config/checkin/${configID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPublicCheckInConfig(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/config/checkin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePublicCheckInConfig(
  { publicService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${publicService}/public/config/checkin/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deletePublicCheckInConfig(
  { publicService },
  authenticationToken,
  { configID },
) {
  const url = `${publicService}/public/config/checkin/${configID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchWorkItemDefSubTypes(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/queue/workitemdefinitiontypesubtypes/checkin`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCheckInCategories(
  { publicService },
  authenticationToken
) {
  const url = `${publicService}/public/config/checkin/categories`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPublicPortalMode(
  { publicService },
  authenticationToken
) {
  const url = `${publicService}/appraisal/publicportalmode`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePublicPortalMode(
  { publicService },
  authenticationToken,
  { payload }
) {
  const url = `${publicService}/appraisal/publicportalmode`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}